import { Component, OnInit } from '@angular/core'

@Component({

    templateUrl: './je-website-component.html'
})

export class JEWebSite implements OnInit {

    ngOnInit() {

        window.open("https://rxmedicareplans.com/", "_blank");
    }
}

